import * as React from "react";

function OfxIcon(props) {
  return (
    <svg
      id="Camada_2"
      data-name="Camada 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 584.15 399.66"
      {...props}
    >
      <path
        class="cls-1"
        d="M577.64,139.13c-8.68-8.68-22.75-8.68-31.43,0l-7.79,7.79-12.58,12.58-77.16,77.16-19.38-19.38h0s-10.16-10.16-10.16-10.16l-6.51-6.51c-8.68-8.68-22.75-8.68-31.43,0-8.68,8.68-8.68,22.75,0,31.43l6.51,6.51h0s20.54,20.55,20.54,20.55l23.16,23.16,9.43,9.43c4.33,4.33,11.35,4.35,15.69,0l.08-.08s.04-.03.06-.04l108.93-108.93h0s4.27-4.28,4.27-4.28l7.79-7.79c4.34-4.34,6.51-10.03,6.51-15.72s-2.17-11.38-6.51-15.72"
      />
      <rect
        class="cls-1"
        x="218.02"
        y="106.71"
        width="150"
        height="44.27"
        rx="22.14"
        ry="22.14"
      />
      <rect
        class="cls-1"
        x="161.87"
        y="177.69"
        width="170"
        height="44.27"
        rx="22.14"
        ry="22.14"
      />
      <rect
        class="cls-1"
        x="55.72"
        y="248.67"
        width="210"
        height="44.27"
        rx="22.14"
        ry="22.14"
      />
      <rect
        class="cls-1"
        x="0"
        y="248.67"
        width="44.27"
        height="44.27"
        rx="22.14"
        ry="22.14"
      />
      <rect
        class="cls-1"
        x="106.15"
        y="177.69"
        width="44.27"
        height="44.27"
        rx="22.14"
        ry="22.14"
      />
      <g>
        <path
          class="cls-1"
          d="M426.41,307.96h0c-12.25,0-22.17,9.93-22.18,22.17v3.53c0,3.81-1.01,7.39-2.78,10.5h-.06c-1.12,1.98-2.53,3.76-4.16,5.29-2.94,2.7-6.62,4.64-10.72,5.47-1.27.24-2.58.37-3.92.37l-178.51.08c-12.29,0-22.28-9.73-22.28-21.72v-3.53c0-12.25-9.93-22.17-22.18-22.17h0c-12.25,0-22.18,9.93-22.18,22.18v3.53c.17,18.27,7.67,34.76,19.69,46.69,12.04,11.93,28.62,19.3,46.92,19.3h178.54c.57,0,1.13-.04,1.69-.06.45-.02.9-.02,1.35-.05.67-.04,1.34-.1,2-.15.46-.04.91-.07,1.37-.12.65-.07,1.3-.16,1.94-.25.46-.06.92-.12,1.38-.19.63-.1,1.25-.22,1.88-.33.46-.09.93-.16,1.39-.26.61-.13,1.21-.27,1.81-.42.47-.11.93-.21,1.39-.33.59-.15,1.17-.32,1.75-.49.47-.14.94-.26,1.4-.41.57-.18,1.12-.37,1.68-.56.47-.16.94-.31,1.4-.48.54-.2,1.07-.42,1.6-.63.47-.19.94-.37,1.41-.57.51-.22,1.02-.45,1.53-.68.47-.21.95-.42,1.41-.65.49-.24.97-.49,1.45-.74.47-.24.94-.48,1.41-.73.46-.25.92-.52,1.38-.79.47-.27.94-.53,1.4-.82.44-.27.87-.55,1.31-.83.46-.3.93-.59,1.38-.89.42-.29.83-.59,1.25-.88.45-.32.91-.64,1.35-.97.41-.3.8-.62,1.2-.93.44-.34.88-.68,1.3-1.03.39-.32.77-.66,1.15-.99.42-.36.84-.72,1.25-1.09.38-.34.74-.7,1.11-1.05.33-.31.67-.62.99-.94.07-.06.13-.13.19-.2.06-.06.13-.12.2-.19.61-.61,1.2-1.24,1.78-1.87.07-.07.13-.15.2-.23.58-.64,1.14-1.29,1.7-1.95.21-.25.42-.51.63-.76.4-.49.8-.99,1.19-1.5.23-.3.46-.6.68-.9.36-.49.71-.98,1.06-1.48.22-.31.44-.62.65-.93.46-.69.92-1.38,1.35-2.09.28-.46.55-.92.83-1.38.24-.4.47-.8.7-1.2.27-.48.53-.97.79-1.46.17-.33.34-.66.51-.99.27-.54.54-1.08.8-1.63.11-.24.22-.48.33-.72.97-2.11,1.84-4.28,2.59-6.51.02-.05.04-.1.05-.15.25-.75.49-1.51.71-2.28.03-.1.06-.2.09-.3,1.66-5.71,2.59-11.74,2.65-17.98v-3.53c0-12.25-9.93-22.18-22.18-22.18Z"
        />
        <path
          class="cls-1"
          d="M448.59,11.1c0-6.12-4.95-11.1-11.1-11.1h-234.05c-18.27.17-34.76,7.68-46.69,19.69-11.93,12.04-19.3,28.62-19.3,46.92v73.95c0,12.23,9.92,22.15,22.15,22.15h0c12.23,0,22.15-9.92,22.15-22.16l-.02-73.92c0-12.29,9.73-22.28,21.72-22.28l108.57-.03v-.06h92.3v57.96h-.03v58.62c0,12.23,9.92,22.15,22.15,22.15,6.12,0,11.66-2.48,15.67-6.49,4-4.01,6.48-9.55,6.48-15.67v-21.57s0,0,0,0V11.1Z"
        />
      </g>
    </svg>
    // <svg
    //   width={24}
    //   height={24}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    //   {...props}
    // >
    //   <path d="M5.944 2.959c.18-.094.37-.17.569-.244-.155.517.028 1.041.495 1.326.264.161.568.212.856.142.31-.076.582-.283.765-.585.175-.287.35-.58.519-.862.179-.3.365-.61.55-.914.32-.528.206-.963.052-1.235C9.595.31 9.28-.015 8.655 0 5.93.067 3.677 1.153 1.961 3.23.674 4.788.014 6.634 0 8.716c-.004.656.458 1.154 1.099 1.186l.06.002c.589 0 1.065-.43 1.144-1.044.01-.074.011-.143.012-.204l.003-.078c.066-1.278.406-2.398 1.01-3.33.6-.926 1.48-1.696 2.616-2.29zM23.987 15.094c-.042-.578-.577-1.02-1.196-.986-.606.034-1.046.481-1.097 1.113a8.444 8.444 0 00-.017.327c-.007.17-.014.331-.037.484-.194 1.302-.655 2.408-1.37 3.289-.68.838-1.612 1.5-2.773 1.968a1.141 1.141 0 00-.513-1.328c-.558-.33-1.24-.15-1.589.417a89.086 89.086 0 00-1.118 1.864c-.228.395-.231.866-.007 1.23a1.123 1.123 0 001.054.526c.676-.042 1.394-.096 2.088-.266 3.491-.856 6.117-3.844 6.533-7.434.054-.469.068-.851.042-1.204zM7.691 8.364h-.993c-.839 0-1.485.222-1.923.659-.437.437-.659 1.086-.659 1.928v1.992c0 .838.22 1.483.654 1.917.437.438 1.079.66 1.906.66h1.026c.84 0 1.486-.227 1.92-.674.435-.448.656-1.106.656-1.957v-1.944c0-.838-.222-1.485-.66-1.922-.436-.437-1.085-.659-1.927-.659zm.438 2.56v1.998c0 .335-.107.442-.438.442h-1.01c-.27 0-.415-.07-.415-.442v-1.977c0-.319.1-.42.415-.42h1.01c.29 0 .438.06.438.399zM14.506 11.231c.187-.186.281-.45.281-.783 0-.543-.263-.903-.734-1.024v-.056h-1.27v-.41c0-.331.107-.439.44-.443h.506c.676 0 1.063-.393 1.063-1.08 0-.676-.391-1.064-1.074-1.064h-.513c-.84 0-1.487.227-1.92.674-.436.448-.656 1.106-.656 1.956v5.454c0 .683.392 1.075 1.075 1.075h.01c.337 0 .602-.095.788-.281.187-.187.281-.452.281-.788v-2.943h.902c.341 0 .623-.098.815-.281l.006-.006z" />
    //   <path d="M14.916 10.177l.03.034 1.344 1.712-1.449 1.844v.01c-.348.477-.294.988.157 1.418l.011.01c.238.209.483.314.728.314.27 0 .554-.147.782-.404l1.14-1.451 1.118 1.424.01.012c.294.342.592.414.79.414.321 0 .555-.163.723-.304l.014-.013c.458-.43.513-.944.16-1.426v-.01l-1.45-1.844 1.444-1.839v-.009c.168-.227.245-.459.229-.69-.019-.26-.155-.503-.403-.718-.241-.21-.48-.313-.728-.313-.287 0-.555.138-.797.41l-1.125 1.424-1.102-1.398-.01-.012c-.303-.35-.605-.424-.805-.424-.333 0-.567.167-.736.316-.498.444-.525.995-.075 1.513z" />
    // </svg>
  );
}

export default OfxIcon;
